module.exports = __webpack_public_path__ + "static/media/VN.516f9e6b.png";